import {GET, POST} from "../util";
import {formatAsBooleanString} from "@/common/format";

const inspectionUrl = "api/alfa-inspection";
const operationUrl = "api/alfa-operation";

const url = {
	inspection: {
		currentStatus: `${inspectionUrl}/:accountId/status`,
		config: `${inspectionUrl}/static-config`,
		details: `${inspectionUrl}/settings/:settingsId/details`,
		coverage: `${inspectionUrl}/coverage?days=:days`,
	},
	operation: {
		save: `${operationUrl}/settings/save?enable=:enable`,
		enable: `${operationUrl}/settings/:settingsId/enable`,
		disable: `${operationUrl}/settings/:settingsId/disable`,
	}
};

const alfaApi = {
	inspection: {
		getCurrentStatus: (accountId) => {
			return GET(url.inspection.currentStatus.replace(":accountId", accountId));
		},
		getConfig: () => {
			return GET(url.inspection.config);
		},
		getDetails: (settingsId) => {
			return GET(url.inspection.details.replace(":settingsId", settingsId));
		},
		getCoverage: (params, historicalDays) => {
			return POST(url.inspection.coverage.replace(":days", historicalDays), params);
		},
	},
	operation: {
		save: (params = {}, enable) => {
			return POST(url.operation.save.replace(":enable", formatAsBooleanString(enable)), params);
		},
		enable: (settingsId) => {
			return POST(url.operation.enable.replace(":settingsId", settingsId));
		},
		disable: (settingsId) => {
			return POST(url.operation.disable.replace(":settingsId", settingsId));
		},
	}
};

export {alfaApi};
